export default __webpack_public_path__ + "static/media/Equipo-orange.e734f9bd.svg";